import React from 'react';
import { arrayOf, bool, func, number, shape, string } from 'prop-types';
import './SkillGeoJobMatchRow.scss';
import CheckboxInput from 'ps-components/Input/CheckboxInput';
import isEqual from 'lodash/isEqual';
import { PRICING_TYPE } from '../SkillGeoDifferentialReducer';
import classnames from 'classnames';

export class SkillGeoJobMatchRow extends React.Component {
  static propTypes = {
    jobMatch: shape({
      matchId: number,
      surveyJobCode: string,
      surveyCode: string,
      slotJobCode: string,
      slotJobCodeKey: string,
      jobScope: string,
      surveyYear: number,
      surveyTitle: string,
      jobTitle: string,
      geo: number,
      adj: number
    }),
    pricingType: string,
    selectJobMatch: func,
    selectedJobMatches: arrayOf(number),
    defaultChecked: bool,
    setSelectedJobMatches: func
  };

  constructor(props) {
    super(props);
    const { defaultChecked } = this.props;
    let isSelected = false;
    if (defaultChecked !== undefined) {
      isSelected = defaultChecked;
    }
    this.state = {
      isSelected: isSelected
    };

    this.toggleJobMatchSelect = this.toggleJobMatchSelect.bind(this);
  }

  componentDidUpdate(prevProps) {
    const { jobMatch, selectedJobMatches } = this.props;
    if (!isEqual(selectedJobMatches, prevProps.selectedJobMatches)) {
      this.setState({ isSelected: selectedJobMatches.includes(jobMatch.matchId) });
    }
  }

  render() {
    const { jobMatch, pricingType } = this.props;
    const { isSelected } = this.state;

    const rowClassNames = classnames('job-match__row', {
      'slotted-job': pricingType === PRICING_TYPE.SLOTTED
    });
    return (
      <div className={rowClassNames} onClick={this.toggleJobMatchSelect}>
        <div className="job-match__information">
          <div className="job-match__checkbox">
            <CheckboxInput key={jobMatch.matchId} checked={isSelected} onClick={this.toggleJobMatchSelect} />
          </div>
          <div className="job-match__details">
            <div>
              <span className="job-title">{unescape(jobMatch.jobTitle)} </span>
              {pricingType === PRICING_TYPE.PRICED && <span>{jobMatch.surveyJobCode}</span>}
              {pricingType === PRICING_TYPE.SLOTTED && (
                <span>
                  {jobMatch.slotJobCode} {jobMatch.slotJobCodeKey}
                </span>
              )}
            </div>
            {pricingType === PRICING_TYPE.PRICED && (
              <div className="survey-details">
                {jobMatch.surveyTitle} {jobMatch.jobScope}
              </div>
            )}
          </div>
        </div>
        <div className="job-match__geo">{jobMatch.geo}</div>
        <div className="job-match__skill">{jobMatch.adj}</div>
      </div>
    );
  }

  toggleJobMatchSelect() {
    const { jobMatch, selectedJobMatches, setSelectedJobMatches } = this.props;
    let currentSelected = [...selectedJobMatches];
    const selectedJobIndex = currentSelected.indexOf(jobMatch.matchId);
    if (selectedJobIndex === -1) {
      currentSelected.push(jobMatch.matchId);
      this.setState({ isSelected: true });
    } else {
      currentSelected.splice(selectedJobIndex, 1);
      this.setState({ isSelected: false });
    }
    setSelectedJobMatches(currentSelected);
  }
}

export default SkillGeoJobMatchRow;
